(function () {
  const STAR_RATING = '4.5';
  let reviewCount = '3,700';
  let localStorageWorks = false;

  try {
    localStorage.setItem('testKey', 'testValue');
    if (localStorage.getItem('testKey') === 'testValue') {
      localStorageWorks = true;
      localStorage.removeItem('testKey');

      // Get stored value if available
      const productPath = window.location.pathname;
      const storageKey = `amazon_review_count_${productPath}`;
      const storedCount = localStorage.getItem(storageKey);
      if (storedCount) reviewCount = storedCount;
    }
  } catch (e) {}

  function createStarsSVG() {
    return `
      <svg width="120" height="24" viewBox="0 0 120 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="var(--dark-green)" transform="translate(0,0)"/>
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="var(--dark-green)" transform="translate(24,0)"/>
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="var(--dark-green)" transform="translate(48,0)"/>
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="var(--dark-green)" transform="translate(72,0)"/>
        <defs>
          <linearGradient id="halfStar" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="50%" style="stop-color:var(--dark-green); stop-opacity:1" />
            <stop offset="50%" style="stop-color:#C0C0C0; stop-opacity:0.3" />
          </linearGradient>
        </defs>
        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="url(#halfStar)" transform="translate(96,0)"/>
      </svg>
    `;
  }

  function storeReviewCount(count) {
    if (count === reviewCount) return;

    reviewCount = count;

    if (localStorageWorks) {
      const productPath = window.location.pathname;
      const storageKey = `amazon_review_count_${productPath}`;
      try {
        localStorage.setItem(storageKey, count);
      } catch (e) {}
    }
  }

  function buildAriaLabel(count) {
    return `Rated ${STAR_RATING} out of 5 stars, based on ${count} ratings from Amazon`;
  }

  function createWidget(isInline = false) {
    const widget = document.createElement('button');
    widget.type = 'button';
    widget.className = isInline ? 'custom-amazon-rating-inline' : 'custom-amazon-rating';
    widget.setAttribute('aria-label', buildAriaLabel(reviewCount));
    widget.style.cssText =
      'cursor:pointer; margin:' +
      (isInline ? '5px 0' : '10px 0') +
      '; background:none; border:none; padding:0; font:inherit; text-align:left; display:block;';

    widget.innerHTML = `
      <div style="display:flex; align-items:center; font-family:'canada-type-gibson',-apple-system; font-weight:400;">
        <div class="custom-stars" style="display:flex; margin-right:8px;">
          ${createStarsSVG()}
        </div>
        <div style="color:var(--dark-green); font-size:16px; font-weight:400;">
          <span style="font-weight:400;" class="${isInline ? 'review-count-text-inline' : 'review-count-text'}">${reviewCount} ratings</span>
          <span>from Amazon</span>
        </div>
      </div>
    `;

    widget.addEventListener('click', function () {
      const reviewsSection = document.querySelector('.customer-reviews-section');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });

    return widget;
  }

  function updateWidgets(newCount) {
    if (newCount === reviewCount) return;
    storeReviewCount(newCount);
    requestAnimationFrame(() => {
      document.querySelectorAll('.review-count-text, .review-count-text-inline').forEach((el) => {
        el.textContent = `${newCount} ratings`;
      });
      document.querySelectorAll('.custom-amazon-rating, .custom-amazon-rating-inline').forEach((el) => {
        el.setAttribute('aria-label', buildAriaLabel(newCount));
      });
    });
  }

  function insertWidgets() {
    if (!document.querySelector('.custom-amazon-rating')) {
      const container = document.querySelector('.product__info-container');

      if (container) {
        const widget = createWidget(false);
        container.insertBefore(widget, container.firstChild);
      }
    }

    const inlineContainer = document.querySelector('.custom-inline-rating');
    if (inlineContainer && !inlineContainer.querySelector('.custom-amazon-rating-inline')) {
      inlineContainer.appendChild(createWidget(true));
    }
  }

  function handleAmazonWidget() {
    const amazonWidgets = document.querySelectorAll('amazon-product-rating');

    if (amazonWidgets.length > 0) {
      amazonWidgets.forEach((widget) => {
        widget.style.display = 'none';

        // Try to extract review count
        if (widget.shadowRoot) {
          const countElement = widget.shadowRoot.querySelector('.rating-text.ember-bold');
          if (countElement && countElement.textContent) {
            updateWidgets(countElement.textContent.trim());
          }
        }
      });

      insertWidgets();
      return true;
    }

    return false;
  }

  insertWidgets();

  let checkCount = 0;
  const checkInterval = setInterval(() => {
    if (handleAmazonWidget() || ++checkCount >= 10) {
      clearInterval(checkInterval);

      // Final check after delay (using rAF for performance)
      if (handleAmazonWidget()) {
        setTimeout(() => requestAnimationFrame(handleAmazonWidget), 5000);
      }
    }
  }, 500);

  const productInfoContainer = document.querySelector('.product__info-container');
  if (productInfoContainer) {
    const inlineObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          const inlineContainer = document.querySelector('.custom-inline-rating');
          if (inlineContainer && !inlineContainer.querySelector('.custom-amazon-rating-inline')) {
            inlineContainer.appendChild(createWidget(true));
            break;
          }
        }
      }
    });

    inlineObserver.observe(productInfoContainer, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => inlineObserver.disconnect(), 5000);
  }

  window.addEventListener(
    'load',
    () => {
      insertWidgets();
      handleAmazonWidget();
    },
    { once: true }
  );
})();
